{
  "comment": "M4 station modules and recipes (spec §4.2, §6.1-§6.4, §5.7). A station is a set of modules (X4-style). Each production module runs one line per recipe; the line's quantities are multiplied by the module level. Every recipe consumes at least 1 fuel_cells (design §3.2; a schema refinement enforces it). A module buys its inputs and sells its outputs; trade baskets buy and sell every listed ware. Capacity per ware = per-cycle quantity × stockCycles summed over lines and levels, plus the fixed capacities given here (baskets, shipyards per level, the export terminal, the fence, collect lists). targetFill: suppliers restock below it. workforce: need per production-module level and the bonus cap (×1.5). starvedEventS: a line starved this long raises stationStarved. salvageYields: the wares a sold M2 salvage component deposits at condition 1 (scaled by condition; each yield is worth less than the component's M2 base value). Starting values, tune freely. E15 tuning pass (D-TBD: M4 tuning pass): stockCycles 120 and targetFill 0.4 (larger buffers; more stations count as a supplier's internal source); the ice processor cycles in 20 s (fuel cells were the Reach-wide bottleneck, most lines starved on them); habitats consume their basket per 600 s (habitat upkeep was the structural drain on the Authority and Holdfast, which have no income in M4); smaller yard component stocks (yards restock more often); the export terminal takes 90 t of tetherstone and effectively no platinum (1 t, under the smallest lot): capped exports keep the money supply bounded, and a platinum sink that opened every export interval stranded fracture-rig miners on unsellable platinum. Balance round 2 (R2-T1, D-TBD): recipe keys selfFed (on since BR2-G4a for ice_processor.water; with it alone the loop was fixed but two CI soak seeds failed; a ware on both sides is netted, so the ice processor powers its cycle from its own fuel-cell output and can't starve itself once traders empty it; T0 found it starved 45-79% of line time, 96% of that on fuel cells) and partialOutput (D-335 D3: a multi-output line runs while any output has room; default off). 5(e) MC-e2 (D-360 D4, placeholders tuned by MC-e7): refinery.refractory_alloy turns the deep and rim refractory_ore into refractory_alloy, the Mk III rung (input cost ~19,160 cr per cycle, output 23,200 cr, a 21% margin); the alloy is in no trade basket (never the trading_post), and its sim consumers are MC-e3's: the gunship, hauler_large and corvette build costs (yards buy 20 t per level, shipyard.buysPerLevel), the level-3 upgrades of hab, ice_works, fabworks and defense_platform and the defense_platform construction (templates.json; never a template that makes the alloy), and the career Mk III carry. Recipe key ownerOnly (MC-e2, v7 migration calls §2.4, default false): the outputs carry TRADE_BIT.ownerOnly, so only the station's owner faction takes them (its own suppliers move the alloy to its yards); a pilot buys the alloy only at the gate import terminal (RD6) or at a refinery the player owns. Recipe key noPilot (MC-e7b4, D-TBD; replaces ownerOnly on the alloy line): the outputs carry TRADE_BIT.noPilot, so every AI faction's traders, suppliers and constructors buy the alloy at a refinery and carry it to any faction's yard or works site, while the pilot and the player corporation (its ships, suppliers and works, and the no-faction price the pilot sees) are refused unless the corporation owns the refinery; the pilot's alloy source stays the gate import terminal (RD6). Recipe key dormantOn (MC-e2, D-TBD): a line short of that input is dormant, not starved (no stationStarved, no starved seconds), so every refinery and outpost in a region without the ore doesn't flood the Wire or the starvation metrics; short of steel or fuel cells it starves as usual. export_terminal.sells.refractory_alloy (MC-e4, RD6): the gate import terminal sells the imported alloy at the roles.json convoy floor; its capacity (6 t) stays under roles.json trader.minLot, so AI traders never list it as a source.",
  "stockCycles": 120,
  "targetFill": 0.4,
  "workforce": { "needPerLevel": 100, "maxBonus": 0.5 },
  "starvedEventS": 120,
  "modules": [
    {
      "id": "refinery",
      "kind": "production",
      "recipes": [
        { "id": "refinery.steel", "inputs": { "ferrite": 10, "fuel_cells": 1 }, "outputs": { "steel": 6 }, "cycleS": 60 },
        { "id": "refinery.ti_alloy", "inputs": { "titanium": 6, "steel": 2, "fuel_cells": 1 }, "outputs": { "ti_alloy": 4 }, "cycleS": 90 },
        { "id": "refinery.silicon_wafers", "inputs": { "silicates": 10, "fuel_cells": 1 }, "outputs": { "silicon_wafers": 5 }, "cycleS": 60 },
        { "id": "refinery.refractory_alloy", "inputs": { "refractory_ore": 5, "steel": 3, "fuel_cells": 2 }, "outputs": { "refractory_alloy": 4 }, "cycleS": 120, "noPilot": true, "dormantOn": "refractory_ore" }
      ],
      "collect": { "owner": "tethys", "wares": ["tetherstone"], "capacity": 200, "ownerOnlyResale": true }
    },
    {
      "id": "ice_processor",
      "kind": "production",
      "recipes": [
        { "id": "ice_processor.water", "inputs": { "ice": 10, "fuel_cells": 1 }, "outputs": { "water": 6, "fuel_cells": 5 }, "cycleS": 20, "selfFed": true, "partialOutput": true }
      ]
    },
    {
      "id": "fab",
      "kind": "production",
      "recipes": [
        { "id": "fab.hull_plating", "inputs": { "steel": 4, "ti_alloy": 2, "fuel_cells": 1 }, "outputs": { "hull_plating": 4 }, "cycleS": 120 },
        { "id": "fab.electronics", "inputs": { "silicon_wafers": 4, "platinum": 1, "fuel_cells": 1 }, "outputs": { "electronics": 4 }, "cycleS": 120 },
        { "id": "fab.drive_parts", "inputs": { "ti_alloy": 2, "electronics": 1, "fuel_cells": 3 }, "outputs": { "drive_parts": 2 }, "cycleS": 150 },
        { "id": "fab.weapon_parts", "inputs": { "steel": 3, "electronics": 2, "fuel_cells": 1 }, "outputs": { "weapon_parts": 3 }, "cycleS": 120 }
      ]
    },
    {
      "id": "hydroponics",
      "kind": "production",
      "recipes": [{ "id": "hydroponics.food", "inputs": { "water": 6, "fuel_cells": 3 }, "outputs": { "food": 8 }, "cycleS": 60 }]
    },
    {
      "id": "clinic",
      "kind": "production",
      "recipes": [{ "id": "clinic.medical", "inputs": { "water": 4, "electronics": 1, "fuel_cells": 1 }, "outputs": { "medical": 4 }, "cycleS": 90 }]
    },
    {
      "id": "habitat",
      "kind": "habitat",
      "consumes": { "food": 4, "water": 3, "medical": 0.6 },
      "weights": { "food": 0.5, "water": 0.3, "medical": 0.2 },
      "periodS": 600,
      "workersPerLevel": 400,
      "satisfactionRate": 0.1,
      "startSatisfaction": 0.8
    },
    {
      "id": "shipyard",
      "kind": "shipyard",
      "slotsPerLevel": 1,
      "buysPerLevel": { "hull_plating": 160, "electronics": 80, "drive_parts": 60, "weapon_parts": 60, "refractory_alloy": 20 }
    },
    {
      "id": "trading_post",
      "kind": "trade",
      "basket": [
        "ferrite",
        "silicates",
        "ice",
        "titanium",
        "steel",
        "ti_alloy",
        "silicon_wafers",
        "water",
        "fuel_cells",
        "hull_plating",
        "electronics",
        "drive_parts",
        "weapon_parts",
        "food",
        "medical"
      ],
      "capacity": 200
    },
    {
      "id": "export_terminal",
      "kind": "export",
      "buys": { "platinum": 1, "tetherstone": 90 },
      "sells": { "medical": 300, "electronics": 300, "refractory_alloy": 6 }
    },
    { "id": "fence", "kind": "fence", "priceMult": 0.6, "capacity": 200 }
  ],
  "salvageYields": {
    "reactor": { "electronics": 4, "drive_parts": 2 },
    "radiator": { "hull_plating": 1 },
    "weapon": { "weapon_parts": 2 },
    "shieldGen": { "electronics": 3 },
    "thruster": { "drive_parts": 1 },
    "cargoPod": {},
    "dataCore": { "electronics": 2 }
  }
}
